import { SocialMediaResponseProps } from '@/types/socialMediaProps'
import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'

export interface SocialMediaProps {
  socialMedia: SocialMediaResponseProps[]
}

const initialState: SocialMediaProps = {
  socialMedia: [],
}

const socialMediaSlice = createSlice({
  name: 'socialMedia',
  initialState,
  reducers: {
    handleSetSocialMedia(state, action: PayloadAction<SocialMediaProps>) {
      state.socialMedia = action.payload.socialMedia
    },
  },
})

export const { handleSetSocialMedia } = socialMediaSlice.actions

export default socialMediaSlice.reducer
